import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';

const getInitialLang = () => (localStorage.getItem('lang') || 'en').toLowerCase();

const dict = {
    en: {
        save: 'Save',
        discard: 'Discard',
        close: 'Close',
    },
    ru: {
        save: 'Сохранить',
        discard: 'Отмена',
        close: 'Закрыть',
    },
    ua: {
        save: 'Зберегти',
        discard: 'Скасувати',
        close: 'Закрити',
    },
};

const Dialog = ({ lang: langProp, ...props }) => {
    const lang = langProp || getInitialLang();
    const t = useMemo(() => dict[lang] || dict.en, [lang]);
    const resolvedTitle = props.customTitle || (props.fieldsData?.id > 0 ? props.editTitle : props.title);
    const dialogClass = ["modal-dialog", props.dialogSize || "modal-dialog-centered"].join(" ").trim();
    const dialogStyle = { ...(props.dialogStyle || {}) };
    if (props.dialogMaxWidth) {
        dialogStyle.maxWidth = props.dialogMaxWidth;
    }
    const baseZIndex = props.zIndex ?? 101000;
    const wrapperStyle = {
        position: "fixed",
        inset: 0,
        zIndex: baseZIndex,
        overflowY: "auto",
        padding: "20px",
    };
    const modalStyle = { display: 'block' };

    const renderFooter = () => {
        if (props.footerContent) {
            return props.footerContent;
        }
        if (props.hideActions) {
            return (
                <button className="btn btn-secondary" onClick={props.closeDialog}>
                    {t.close}
                </button>
            );
        }
        return (
            <div className="d-flex gap-6 m-0">
                <button id="btn-edit" className="btn btn-primary" onClick={props.saveDialog}>
                    {t.save}
                </button>
                <button
                    className="btn bg-danger-subtle text-danger"
                    data-bs-dismiss="modal"
                    onClick={props.closeDialog}
                >
                    {t.discard}
                </button>
            </div>
        );
    };

    const modalMarkup = (
        <>
            <div style={wrapperStyle}>
                <div className="modal fade show" id="addContactModal" tabIndex="-1" role="dialog" aria-labelledby="addContactModalTitle" aria-modal="true" style={modalStyle}>
                <div
                    className={dialogClass}
                    role="document"
                    style={Object.keys(dialogStyle).length ? dialogStyle : undefined}
                >
                        <div className="modal-content">
                            <div className="modal-header d-flex align-items-center">
                                <h5 className="modal-title">{resolvedTitle}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label={t.close} onClick={props.closeDialog}></button>
                            </div>
                            <div className="modal-body">
                                <div className="add-contact-box">
                                    <div className="add-contact-content">
                                        <div id="addContactModalTitle">{props.children}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">{renderFooter()}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ zIndex: baseZIndex - 1 }}></div>
        </>
    );

    if (typeof document === "undefined" || !document.body || props.disablePortal) {
        return modalMarkup;
    }
    return createPortal(modalMarkup, document.body);
};

export default Dialog;
